export const pixelRunScript = (_goal: string) => {
  return _goal;
  // if (window._tmr) {
  //   window._tmr.push({ type: 'reachGoal', id: 3250487, goal });
  // } else {
  //   console.error('Ошибка: объект _tmr не найден.');
  // }
};
